import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledVoiceInfoForm = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  .input-label {
    margin-bottom: 4px;
  }
`;

const FormTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
`;

export { StyledVoiceInfoForm, FormTitle };
